function Shop_product(element) {
    this.$element = $(element);

    this.selectors = {
	    fieldQuantity: '.js-field-quantity',
	    currentOrder: '.js-current-order',
	    subtotal: '.js-subtotal',
	    buttonAdd: '.js-button-add'
    };
    
    this.data = {
	    productId: 'product-id',
	    pluginId: 'plugin-id',
	    singlePrice: 'single-price',
	    currency: 'currency',
	    productUrl: 'product-url'
    };
    
    this.init = function() {
	    	   
	    this.$fieldQuantity = this.$element.find(this.selectors.fieldQuantity);
	    this.$currentOrder = this.$element.find(this.selectors.currentOrder);
	    this.$subtotal = this.$element.find(this.selectors.subtotal);
	    this.$buttonAdd = this.$element.find(this.selectors.buttonAdd);
	    
	    this.price = this.$element.data(this.data.singlePrice);
	    this.currency = this.$element.data(this.data.currency);
	    this.productId = this.$element.data(this.data.productId);
	    this.pluginId = this.$element.data(this.data.pluginId);
	    this.productUrl = this.$element.data(this.data.productUrl);
	    
	    if (this.$fieldQuantity.length) {
	    	this.$fieldQuantity.on('i4:change', this.$onChangeQuantity.bind(this));
			this.quantity = this.$fieldQuantity.val();
	    } else {
		    this.quantity = 1;
	    }
	    
	    this.$buttonAdd.on('click', this.$onClickAdd.bind(this));
	};
    
    this.$onChangeQuantity = function(event) {
	    event.preventDefault();
	    
	    var quantity = this.$fieldQuantity.val();
	    this.quantity = quantity;
					
		var price = '';
		if (quantity > 0) {
			price = (quantity * this.price).toFixed(2);
		}

		if (price === '') {
			this.$currentOrder.hide();
		} else {
			this.$currentOrder.show();
			this.$subtotal.text(this.currency+' '+price);
		}
    };
    
    this.$onClickAdd = function(event) {
	    event.preventDefault();
	    	    
	    i4_Cart_controller.addProduct(this.productId, {
		   pluginId: this.pluginId,
		   quantity: this.quantity,
		   productUrl: this.productUrl,
		   onSuccess: (function() {
			   this.$fieldQuantity.val(1);
		   }).bind(this)
	    });
    };
}
